import { render, staticRenderFns } from "./MyShoppingList.vue?vue&type=template&id=6f4ec12c&scoped=true"
import script from "./MyShoppingList.vue?vue&type=script&lang=js"
export * from "./MyShoppingList.vue?vue&type=script&lang=js"
import style0 from "./MyShoppingList.vue?vue&type=style&index=0&id=6f4ec12c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4ec12c",
  null
  
)

export default component.exports